import type { TextVariant } from "@qendo/theme";
import { Text, type TextProps } from "react-native";
import {
    Alignment,
    Font,
    type FontSize,
    type FontStyle,
    type FontWeight,
    Leading,
    type TextAlignment,
} from "~/constants/typography";
import { useTheme } from "~/providers/ThemeProvider";

export type BaseTextProps = {
    weight?: FontWeight | "inherit";
    size?: FontSize | "inherit";
    lineHeight?: FontSize | "inherit";
    colour?: TextVariant | "inherit";
    align?: TextAlignment | "inherit";
    decoration?: FontStyle | "inherit";
    inherit?: boolean;
} & TextProps;

export const BaseText = ({
    size,
    colour,
    weight,
    align,
    decoration,
    lineHeight,
    style,
    children,
    inherit,
    ...textProps
}: BaseTextProps) => {
    const { text } = useTheme();

    const font_size = size ?? (inherit ? "inherit" : "base");
    const font_weight = weight ?? (inherit ? "inherit" : "regular");
    const font_colour = colour ?? (inherit ? "inherit" : "primary");
    const font_align = align ?? (inherit ? "inherit" : "auto");
    const font_decoration = decoration ?? (inherit ? "inherit" : "normal");
    const font_leading = lineHeight ?? (inherit ? "inherit" : font_size);

    return (
        <Text
            {...textProps}
            style={[
                font_size !== "inherit" && Font[font_size],
                font_decoration !== "inherit" && Font[font_decoration],
                font_weight !== "inherit" && Font[font_weight],
                font_align !== "inherit" && Alignment[font_align],
                font_leading !== "inherit" && Leading[font_leading],
                font_colour !== "inherit" && text[font_colour],
                style,
            ]}
        >
            {children}
        </Text>
    );
};
